export var DashboardType;
(function (DashboardType) {
    DashboardType["Admin"] = "Admin";
    DashboardType["User"] = "User";
})(DashboardType || (DashboardType = {}));
